import React, { useState } from 'react';
import { Card, Button, Modal, TextArea, Icon } from 'semantic-ui-react';
import moment from 'moment';
import addNote from '../api/add-note';

const Note = ({ player, game, onNoteUpdated }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [noteText, setNoteText] = useState(player.note?.text || '');
    const [isCreating, setIsCreating] = useState(!player.note);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    const handleSaveNote = () => {
        // if (!noteText.trim()) {
        //     setErrorMsg('Note cannot be empty');
        //     return;
        // }

        setLoading(true);
        setErrorMsg(null);

        addNote(null, null, game, player.guid, noteText, (err) => {
            setLoading(false);
            if (err) {
                setErrorMsg(err);
                return;
            }
            setIsEditing(false);
            // Call the callback to refresh player data
            if (onNoteUpdated) {
                onNoteUpdated();
            }
        });
    };

    const handleCancel = () => {
        setNoteText(player.note?.text || '');
        setIsEditing(false);
        setErrorMsg(null);
    };

    const formatDate = (dateString) => {
        return moment(dateString).format('lll');
    };

    return (
        <div>
            <Card.Content>
                <Card.Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>Note</span>
                    <Button
                        size="mini"
                        icon={player.note ? "edit" : "plus"}
                        onClick={() => setIsEditing(true)}
                        style={{ padding: '4px' }}
                    />
                </Card.Header>
                <Card.Description>
                    {player.note ? (
                        <>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{player.note.text}</div>
                            <div style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
                                <div>Created: {formatDate(player.note.createdAt)}</div>
                                <div>Updated: {formatDate(player.note.updatedAt)}</div>
                            </div>
                        </>
                    ) : (
                        <div style={{ color: '#999', fontStyle: 'italic' }}>
                            No note yet. Click the + button to add one.
                        </div>
                    )}
                </Card.Description>
            </Card.Content>

            <Modal open={isEditing} onClose={handleCancel} size="small">
                <Modal.Header>{player.note ? 'Edit Note' : 'Add Note'}</Modal.Header>
                <Modal.Content>
                    <TextArea
                        placeholder="Enter note text (optional)..."
                        value={noteText}
                        onChange={(e) => setNoteText(e.target.value)}
                        style={{ minHeight: '150px', width: '100%' }}
                        fluid
                    />
                    {errorMsg && (
                        <div style={{ color: 'red', marginTop: '10px' }}>
                            <Icon name="warning" />
                            {errorMsg}
                        </div>
                    )}
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={handleCancel} secondary disabled={loading}>
                        Cancel
                    </Button>
                    <Button onClick={handleSaveNote} primary loading={loading}>
                        {player.note ? 'Save' : 'Create'}
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default Note; 